import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex font-montserrat flex-col justify-center items-center" }
const _hoisted_2 = {
  key: 0,
  class: "bg-green-600 border border-green-600 my-[10px] z-[1000000000000] text-white text-center fixed md:top-[80px] top-[60px] shadow-lg left-[50%] translate-x-[-50%] font-bold flex justify-center items-center rounded-[5px] max-w-[450px] w-[90%] p-[20px]"
}
const _hoisted_3 = {
  key: 1,
  class: "bg-red-600 border border-red-600 my-[10px] text-white text-center fixed md:top-[80px] top-[60px] shadow-lg left-[50%] translate-x-[-50%] font-bold flex justify-center items-center z-[1000000000000] rounded-[5px] max-w-[450px] w-[90%] p-[20px]"
}
const _hoisted_4 = { class: "relative" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "md:h-[80px] h-[50px]" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "absolute z-[1000000] text-left bg-black/50 px-[20px] md:px-[50px] text-white top-0 left-0 right-0 bottom-0 w-full flex items-center flex-col justify-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "md:my-[50px] my-[20px]" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "text-4xl md:text-6xl font-bold uppercase text-center opacity-100" }, "Actualités")
  ])
], -1)
const _hoisted_7 = { class: "w-full my-[10px] px-[10px] flex justify-center relative items-center" }
const _hoisted_8 = { class: "flex w-full relative" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  for: "A_recherche",
  class: "absolute cursor-pointer p-[10px] top-0 right-0 text-cyan-600"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-search" })
], -1)
const _hoisted_10 = { class: "container max-w-[1024px]" }
const _hoisted_11 = { class: "text-2xl px-4 font-bold text-center my-[20px]" }
const _hoisted_12 = { class: "flex flex-wrap justify-center items-center w-full" }
const _hoisted_13 = { class: "flex justify-center items-center my-8 space-x-4" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  disabled: true,
  class: "bg-gray-200 text-gray-700 font-bold py-2 px-4 rounded cursor-pointer"
}
const _hoisted_16 = ["disabled"]

import One_news from '../components/One_news.vue';
import HeaderComponent from '../components/HeaderComponent.vue'
import carouselBranding from '../components/CarouselBranding.vue'
import { ref, onMounted, computed } from 'vue';
import { useRouter } from 'vue-router';
import FooterComponent from '@/components/FooterComponent.vue';
import axios from 'axios'
import axiosInstance from '@/plugins/axios';

const initialSlide = 1;
const canSlide = false;
const pageSize = 6; 

export default /*#__PURE__*/_defineComponent({
  __name: 'News',
  setup(__props) {

const pageTitle = ref('IronSecur | News'); 
const email = ref('');
const loading = ref(false);
const successMessage = ref('');
const errorMessage = ref('');

const news = ref<any[]>([]);
const filteredNews = ref<any[]>([]);



const subscribe = () => {
  loading.value = true;

  axiosInstance.post('/subscribers/', { email: email.value })
    .then(response => {
      loading.value = false;

      if (response.status === 200 || response.status === 201 || response.status === 204) {
        successMessage.value = 'Email envoyé avec succès !';
        hideSuccessMessageAfterDelay();
        email.value= '';
      } else {
        successMessage.value = '';
      }
    })
    .catch(error => {
      loading.value = false;
      console.error(error);
      if (error.response && error.response.status === 400 && error.response.data && error.response.data.email && error.response.data.email[0] === 'This email adress has already used') {
          successMessage.value = 'Cet email est déjà enregistré.';
          hideSuccessMessageAfterDelay();
          email.value = '';
      } else {
          errorMessage.value = 'Une erreur s\'est produite. Veuillez réessayer.';
          hideErrorMessageAfterDelay();
      }
  });
};

const hideSuccessMessageAfterDelay = () => {
  setTimeout(() => {
    successMessage.value = ''; 
  }, 5000);
};

const hideErrorMessageAfterDelay = () => {
  setTimeout(() => {
    errorMessage.value = ''; 
  }, 5000);
};


onMounted(() => {
    document.title = pageTitle.value; 
});



// ... (votre code existant)

const fetchAllNews = async () => {
    try {
        let allNews: any[] = [];
        let nextPage = '/news/';

        while (nextPage) {
            const response = await axiosInstance.get(nextPage);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                const { results, next } = response.data;
                allNews = allNews.concat(results);
                nextPage = next;
            } else {
                nextPage = null;
            }
        }

        return allNews;
    } catch (error) {
        console.error('Erreur lors du chargement des news', error);
        return [];
    }
};

const handleSearch = async (event: any) => {
    const searchTerm = event.target.value.toLowerCase().trim();

    if (!searchTerm) {
        filteredNews.value = news.value;
    } else {
        const allNews = await fetchAllNews();

        if (allNews.length > 0) {
            filteredNews.value = allNews.filter(newsDetail => {
                return (
                    (newsDetail.title && newsDetail.title.toLowerCase().includes(searchTerm)) ||
                    (newsDetail.content && newsDetail.content.toLowerCase().includes(searchTerm))
                );
            });
        }
    }
};


 

onMounted(async () => {
  document.title = pageTitle.value;
  await fetchNews(); 
  try {
    const response = await axiosInstance.get('/news/');
    if (response.status === 200 || response.status === 201 || response.status === 204) {
      const fetchedNews = response.data.results;
      // Sort fetched news by date if needed
      fetchedNews.sort((a: any, b: any) => {
        return new Date(b.date).getTime() - new Date(a.date).getTime();
      });
      news.value = fetchedNews;
      filteredNews.value = fetchedNews;
    }
  } catch (error) {
    console.error('Erreur lors du chargement des news', error);
  }
});

const currentPage = ref(1);
const hasPreviousPage = ref(false);
const hasNextPage = ref(false);

const loadNews = async (page: number) => {
  try {
    const response = await axiosInstance.get(`/news/?page=${page}&page_size=${pageSize}`);

    if (response.status === 200 || response.status === 201 || response.status === 204) {
      const { results, previous, next } = response.data;
      results.sort((a: any, b: any) => {
        return new Date(a.date).getTime() - new Date(b.date).getTime();
      });
      filteredNews.value = results;
      hasPreviousPage.value = !!previous;
      hasNextPage.value = !!next;
    }
  } catch (error) {
    console.error('Erreur lors du chargement des news', error);
  }
};


const loadPreviousPage = () => {
  if (hasPreviousPage.value) {
    currentPage.value--;
    loadNews(currentPage.value);
  }
};

const loadNextPage = () => {
  if (hasNextPage.value) {
    currentPage.value++;
    loadNews(currentPage.value);
  }
};

onMounted(() => {
  loadNews(currentPage.value);
});

const fetchNews = async () => {
    try {
        const response = await axiosInstance.get('/news/');
        if (response.status === 200 || response.status === 201 || response.status === 204) {
            const fetchedNews = response.data.results;
          
            // Trier les news par date
            fetchedNews.sort((a, b) => new Date(b.date) - new Date(a.date));

            news.value = fetchedNews;
            filteredNews.value = fetchedNews;
        }
    } catch (error) {
        console.error('Erreur lors du chargement des news', error);
    }
};


const totalPageCount = ref(0);

const fetchTotalPageCount = async () => {
  try {
    const response = await axiosInstance.get('/news/');
    if (response.status === 200 || response.status === 201 || response.status === 204) {
      const totalNews = response.data.count;
      totalPageCount.value = Math.ceil(totalNews / pageSize);
    }
  } catch (error) {
    console.error('Erreur lors du chargement du nombre total de pages', error);
  }
};

onMounted(() => {
  fetchTotalPageCount();
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(HeaderComponent),
    (successMessage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(successMessage.value), 1))
      : _createCommentVNode("", true),
    (errorMessage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(errorMessage.value), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createVNode(carouselBranding, {
        "initial-slide": initialSlide,
        "can-slide": canSlide
      }),
      _hoisted_6
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("input", {
          type: "text",
          id: "A_recherche",
          class: "w-full p-[10px] border border-gray-500 outline-none focus:border-cyan-600",
          onInput: _cache[0] || (_cache[0] = ($event: any) => (handleSearch($event))),
          placeholder: "Filtrer à partir du nom"
        }, null, 32)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", null, [
        _createElementVNode("h1", _hoisted_11, _toDisplayString(_ctx.$t('news_title')), 1),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(One_news, { news: filteredNews.value }, null, 8, ["news"])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("button", {
          onClick: loadPreviousPage,
          disabled: !hasPreviousPage.value,
          class: _normalizeClass({ 'bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded': hasPreviousPage.value, 'bg-gray-300 text-gray-500 cursor-not-allowed py-2 px-4 rounded': !hasPreviousPage.value })
        }, " Previous ", 10, _hoisted_14),
        _createElementVNode("button", _hoisted_15, _toDisplayString(currentPage.value) + " / " + _toDisplayString(totalPageCount.value), 1),
        _createElementVNode("button", {
          onClick: loadNextPage,
          disabled: !hasNextPage.value,
          class: _normalizeClass({ 'bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded': hasNextPage.value, 'bg-gray-300 text-gray-500 cursor-not-allowed py-2 px-4 rounded': !hasNextPage.value })
        }, " Next ", 10, _hoisted_16)
      ])
    ]),
    _createVNode(FooterComponent)
  ]))
}
}

})